export default "__VITE_ASSET__558f5fa5__"